export enum ClientAuthApiTags {
  Registration = 'registration',
}

export const ClientAuthApiTagTypes = Object.values(ClientAuthApiTags);
